import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

/**
 * This function returns the translation key for the given calculation state.
 * @param state
 * @returns The translation key for the given calculation state.
 */
export function getCalculationStateTranslationKey(
	state: Enums<"calculationState">,
): TranslationKey {
	switch (state) {
		case "pending":
			return "calculations.pending";
		case "locked":
			return "calculations.locked";
	}
}
